import { UserInfo } from 'app/models/User'
import { get } from 'app/utils/axios/kheti'

interface Response {
  data: UserInfo
}

const fetchUserDetails = async () => {
  try {
    const url = `${process.env.KHETI_URL}/user/v1/groups`
    const response = await get<Response>(url, {
      app_code: process.env.APP_CODE,
    })
    return response.data
  } catch (e) {
    return null
  }
}

export default fetchUserDetails
